import * as types from '../mutations-types'
import {fetchAgenciesTree, createAgency, updateAgency, deleteAgency} from '../../utils/api'

import {createActionHelpers} from 'vuex-loading'
import Vue from 'vue'

const {startLoading} = createActionHelpers({
  moduleName: 'loading'
})
// STATE
const state = {
  agenciesMapObj: {},
  agenciesBase: [],
  superParents: [],
  agenciesMap: null,
  agencySelected: null,
  agenciesTree: [],
  agencyNameRules: [
    v => !!v || 'El Nombre es requerido',
    v =>
      (v && v.length >= 3) ||
      'Un Nombre válido debe contener por lo menos 3 letras'
  ]
}
// GETTERS
const getters = {
  agenciesMapObj: state => state.agenciesMapObj,
  agenciesBase: state => state.agenciesBase,
  superParents: state => state.superParents,
  agenciesMap: state => state.agenciesMap,
  agencySelected: state => state.agencySelected,
  agenciesTree: state => state.agenciesTree,
  agencies: state => state.agencies,
  agencyNameRules: state => state.agencyNameRules
}
// ACTIONS
const actions = {
  createAgencyAction({dispatch}, payload) {
    return new Promise(async(resolve, reject) => {
      const response = await startLoading(dispatch, 'Creating agency', () => {
        return createAgency(payload)
      })
      if (response) {
        resolve(response)
      }
      reject(new Error('Error creating Agency'))
    })
  },
  updateAgencyAction({dispatch}, payload) {
    return new Promise(async(resolve, reject) => {
      const response = await startLoading(dispatch, `Updating agency ${payload.id}`, () => {
        return updateAgency(payload)
      })
      if (response) {
        resolve(response)
      }
      reject(new Error('Error updating Agency'))
    })
  },
  deleteAgencyAction({dispatch}, id) {
    return new Promise(async(resolve, reject) => {
      const response = await startLoading(dispatch, `Deleting agency ${id}`, () => {
        return deleteAgency(id)
      })
      if (response) {
        resolve(response)
      }
      reject(new Error('Error deleting Agency'))
    })
  },
  fetchAgenciesTreeAction({commit, dispatch, rootGetters}, from = 'not init') {
    // if (from === 'init') commit(types.SHOW_INIT_DIALOG, true)
    return new Promise(async(resolve, reject) => {
      try {
        const agenciesTree = await startLoading(dispatch, 'fetchingAgenciesTree', () => {
          return fetchAgenciesTree()
        })
        // console.log('agenciesTree: ', agenciesTree)
        if (agenciesTree) {
          commit(types.SET_AGENCIES_BASE, agenciesTree.data)

          Vue.prototype.$worker.run(obj => {
            const agenciesMap = []
            let superParentId = null
            const superParents = []
            let superParentCounter = 1
            function recursiveSearchIn(obj) {
              for (let index = 0; index < obj.length; index++) {
                const element = obj[index]

                if (element.parentId === null) {
                  superParentId = element.id
                  superParents.push([superParentId, superParentCounter])
                  superParentCounter++
                }

                if (element.id) {
                  const mapMatch = [element.id, {name: element.name, superParentId: superParentId}]
                  agenciesMap.push(mapMatch)
                }
                if (element.children !== undefined && element.children.length > 0) recursiveSearchIn(element.children)
              }
            }
            recursiveSearchIn(obj)
            return {agenciesMap, superParents}
          }, [agenciesTree.data])
            .then(result => {
              const agenciesMap = new Map(result.agenciesMap)
              // console.log('AGENCIES MAP: ', agenciesMap)
              commit(types.FETCH_AGENCIES_MAP, agenciesMap)

              let obj = {}
              agenciesMap.forEach(function(value, key) {
                obj[key] = value
              })
              // console.log('MAP TO OBJ: ', obj)
              commit(types.SET_AGENCIES_MAP_OBJ, obj)

              const superParentsMap = new Map(result.superParents)
              commit(types.FETCH_SUPER_PARENTS, superParentsMap)
              // console.log('FROM: ', from)
              // if (from === 'init') dispatch('lastPositions')
            })
            .catch(error => {
              console.error('ERROR WORKER', error)
            })

          let agenciesTreeResult = agenciesTree.data
          const role = rootGetters['auth/role']
          let agenciesTreeTemp = []
          let agenciesTreeFiltered = []
          if (role.length > 0) {
            role.forEach(role => {
              agenciesTreeTemp = agenciesTreeResult.filter(item => item.id === role)
              agenciesTreeFiltered = agenciesTreeFiltered.concat(agenciesTreeTemp)
            })
            agenciesTreeResult = agenciesTreeFiltered
          }
          // console.log('agenciesTreeResult: ', agenciesTreeResult)
          commit(types.FETCH_AGENCIES_TREE, agenciesTreeResult)
          resolve(agenciesTree)
        }
        reject(new Error('Error Fetching Agencies Tree'))
      } catch (error) {
        console.error('fetchAgenciesTreeAction ERROR: ', error.response.status)
        if (error.response.status === 401) dispatch('auth/logout')
      }
    })
  },
  agencySelectedAction({commit}, agency) {
    commit(types.AGENCY_SELECTED, agency)
  }
}
// MUTATIONS
const mutations = {
  [types.SET_AGENCIES_MAP_OBJ](state, data) {
    state.agenciesMapObj = data
  },
  [types.SET_AGENCIES_BASE](state, data) {
    state.agenciesBase = data
  },
  [types.FETCH_SUPER_PARENTS](state, data) {
    state.superParents = data
  },
  [types.FETCH_AGENCIES_MAP](state, data) {
    state.agenciesMap = data
  },
  [types.AGENCY_SELECTED](state, agency) {
    state.agencySelected = agency
  },
  [types.FETCH_AGENCIES_TREE](state, agenciesTree) {
    // console.log('AGENCIES TREE: ', agenciesTree)
    state.agenciesTree = agenciesTree
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/agencies.js